module.exports = __webpack_public_path__ + "img/splash-image-1.d2bf5c57.png";